// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e84395f2","977":"7f59b1dc"}[chunkId] + ".chunk.js";
};